<script setup lang="ts">
import type { AlertDialogActionProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { AlertDialogAction } from "reka-ui"
import { cn } from "@/lib/utils"
import { buttonVariants } from '@/core/components/ui/button'

const props = defineProps<AlertDialogActionProps & { class?: HTMLAttributes["class"] }>()

const delegatedProps = reactiveOmit(props, "class")
</script>

<template>
  <!-- Reka renders type="button", and Vuetify's reset `[type=button] { color: inherit }`
       loads after Tailwind with the same specificity: the text color must be important. -->
  <AlertDialogAction v-bind="delegatedProps" :class="cn(buttonVariants(), '!text-slate-50', props.class)">
    <slot />
  </AlertDialogAction>
</template>
